#import "./EntityDocumentsFields.graphql"
mutation AttachTravelerDocument($input: AttachTravelerDocumentInput!) {
  attachTravelerDocument(input: $input) {
    entityDocuments {
      ...EntityDocumentsFields
    }
  }
}
